import { useCallback, useEffect, useRef, useState } from "react";
import is from "@sindresorhus/is";
import { Grid, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";

import ImagePlaceholder from "../ImagePlaceholder/ImagePlaceholder";
import Popup from "../Popup/Popup";

import actions from "../../../data/actions";

const HEIGHT = 400;
const ROWS = 2;

const Gallery = props => {
  const theme = useTheme();

  const [currentPost, setCurrentPost] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [posts, setPosts] = useState();

  const bgcolor = theme.palette.background.paperAlt;
  const color = theme.palette.getContrastText(bgcolor);

  const popupOnClose = useCallback(() => setPopupOpen(false), []);
  const postOnClick = useCallback(post => {
    setCurrentPost(post);
    setPopupOpen(true);
  }, []);

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  // (init) -> posts
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getGalleryPosts())
      .then(posts => setPosts(posts))
      .catch(error => console.log(error));
  }, []);

  return (
    <>
      {is.nonEmptyArray(posts) && (
        <>
          <Paper elevation={0} square sx={{ bgcolor, color }}>
            <Container disableGutters maxWidth="lg">
              <Swiper
                breakpoints={{
                  [theme.breakpoints.values.sm]: {
                    slidesPerView: 4,
                    grid: {
                      rows: 2
                    }
                  },
                  [theme.breakpoints.values.md]: {
                    slidesPerView: 6,
                    grid: {
                      rows: 2
                    }
                  }
                }}
                grid={{ fill: "row", rows: 2 }}
                modules={[Grid, Navigation, Pagination]}
                onBeforeInit={swiper => {
                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;
                }}
                slidesPerView={2}
                spaceBetween={0}
                style={{ "--swiper-pagination-color": "#fff" }}
              >
                {posts.map((post, index) => (
                  <SwiperSlide key={index} onClick={() => postOnClick(post)} style={{ cursor: "pointer", "--swiper-pagination-color": "#fff" }}>
                    {is.plainObject(post.featuredMedia.sourceUrl) ? (
                      <Box
                        sx={{
                          backgroundImage: `url(${
                            post.featuredMedia.sourceUrl.mediumLarge ?? post.featuredMedia.sourceUrl.medium ?? post.featuredMedia.sourceUrl.full
                          })`,
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: HEIGHT / ROWS
                        }}
                      />
                    ) : (
                      <ImagePlaceholder size={HEIGHT / ROWS / 2} sx={{ height: HEIGHT / ROWS }} />
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
            </Container>
          </Paper>
          <Popup open={popupOpen} onClose={popupOnClose}>
            {is.plainObject(currentPost) && (
              <>
                <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
                  {currentPost.title}
                </Typography>
                {currentPost.content.html}
              </>
            )}
          </Popup>
        </>
      )}
    </>
  );
};

export default Gallery;
